// --------------------------------------------------------------------------
// This component is responsible for the UI context and what to do with
// results
// --------------------------------------------------------------------------
// 3rd party dependencies
// --------------------------------------------------------------------------

import React from 'react';

// --------------------------------------------------------------------------
// Other components
// --------------------------------------------------------------------------

import WineScanner from '../wine-scanner';

// --------------------------------------------------------------------------
// Internal dependencies
// --------------------------------------------------------------------------

//import PastResults from './past-results.js';
import Status from './status.js';
import CameraAccessError from './camera-access-error';
import RequestAccessView from './request-access-view.js';
import SingleResult from './single-result.js';
import MultipleResults from './multiple-results.js';

import lookup from './words.js';
import event from '../../helpers/event.js'

// --------------------------------------------------------------------------

import styles from './index.module.css';

// --------------------------------------------------------------------------

const maxPastResultLength = 10;

const revealSearchButtonAfter = 10; // seconds

// --------------------------------------------------------------------------call asyn

class WineEventsScanner extends React.Component {

    // ----------------------------------------------------------------------
    // initialises scan
    // handles stop request
    // processes result
    // ----------------------------------------------------------------------

    constructor(props) {
        
        super(props);
        
        this.state = {
            timeLastStarted                 : (new Date()).getTime(),
            scanningTime                    : 0,
            timerHandle                     : null,
            scanning                        : false,
            requestedCameraAccess           : false,
            requestedCameraAccessResponded  : false,
            hasCameraAccess                 : false,
            status                          : null,
            wines                           : [],
            selectedWine                    : null,
            pastResults                     : [],
            validCameraIds                  : [],
            useCameraId                     : null,//localStorage['lastGoodCameraId']
            internetFlag                    : 0 // if changes - other components know internet might be available

        };

        /*
        let scannedWineData = localStorage['scannedWines'];
        if(scannedWineData!=null) {
            let scannedWines = JSON.parse(scannedWineData);
            this.state.pastResults = scannedWines;
        }
        */
        
    }

    // ----------------------------------------------------------------------

    componentDidMount() {
        this.getValidCameraIds();
    }

    // ----------------------------------------------------------------------

    getNextCameraId() {

        if(this.state.validCameraIds.length<1) return null;

        let nextId = this.state.validCameraIds[0];
        
        for(let i=0; i<this.state.validCameraIds.length-1; i++) {
            if(this.state.validCameraIds[i]==this.state.useCameraId) {
                nextId = this.state.validCameraIds[i+1];
            }
        }

        return nextId;

    }

    // ----------------------------------------------------------------------

    retryInternet() {
        this.setState( (state) => {return { internetFlag: Math.random() } });
    }

    // ----------------------------------------------------------------------

    switchToNextCamera() {

        let id = this.getNextCameraId();
        
        if(id==null) {
        
            this.setState( (state => { return {useCameraId:null, hasCameraAccess: false } }));
            console.log(`No valid camera to switch to`);
        
        } else {
        
            this.setState( (state => { return {useCameraId:id, hasCameraAccess: true } }));
            console.log(`Switching to ${id}`);
        
        }
    }

    // ----------------------------------------------------------------------

    async getValidCameraIds() {
        
        console.log('Building up list of cameras');

        let rawDevices = await navigator.mediaDevices.enumerateDevices();
        let validCameraIds = [];
        
        for(let i=0; i<rawDevices.length; i++) {
            let device = rawDevices[i];
            if(device.kind=='videoinput') {
                validCameraIds.push(device.deviceId);
            }
        }

        this.setState( (state) => { return { validCameraIds : validCameraIds } });
        
        return true;

    }

    // ----------------------------------------------------------------------

    stopScanning() {
        
        if(this.state.timerHandler!=null) clearInterval(this.state.timerHandle);

        this.setState( (state) => { return { scanning:false, timerHandle:null, wines: [], selectedWine: null } } );
        
    }

    // ----------------------------------------------------------------------

    startScanning(id) {

        // first lets see if we can
        if(!this.state.requestedCameraAccess) {

            this.setState((state) => { return { requestedCameraAccess : true } } );
            
            let self = this;
            
            navigator.mediaDevices.getUserMedia({video:true}).then( (stream) => {
                console.log('permission accepted');
                self.setState((state) => { return { requestedCameraAccessResponded:true, hasCameraAccess : true } } ); 
                // if we don't do this, we lock out the camera we do want
                stream.getTracks().forEach(function(track) { track.stop(); });
            }).catch(function(err) {
                console.log('permission denied');
                self.setState((state) => { return { requestedCameraAccessResponded:true, hasCameraAccess : false } } ); 
            });

        }
        
        // if a camera worked before, use it again!
        if(id==null) { console.log('Using last good id'); id = localStorage['lastGoodCameraId']; }
                
        let self = this;
        let updateTimer = function() {
            let scanningTime = (new Date()).getTime() - self.state.timeLastStarted;
            self.setState( (state) => { return { scanningTime : Math.round(scanningTime/100)/10 } } );
        }
        let timerHandle = setInterval(updateTimer, 100 );
        
        this.setState( (state) => { return {

            timeLastStarted     : (new Date()).getTime(),
            timerHandle         : timerHandle,
            scanning            : true,
            scanningTime        : 0,
            useCameraId         : id,
            wines               : [],
            status              : 'scanning',
            statusData          : null
        } } );

    }

    // ----------------------------------------------------------------------

    onScannerError(err) {

        console.log(err);
        
        // remove from list
        let curId = this.state.useCameraId;
        
        let newIds = this.state.validCameraIds.filter(x => x!=curId);
        
        if(newIds.length!=this.state.validCameraIds.length) {

            console.log(newIds);

            if(this.state.validCameraIds.length>1) {

                console.log('looking for id to automatically switch to');
                // first switch to next camera - while still have what will be previous to it!
                this.switchToNextCamera();
                // update list of valid cameras to exclude error camera

                this.setState( (state) => { return {
                    validCameraIds  : newIds
                } } );

            } else {

                this.setState( (state) => { return {
                    validCameraIds  : newIds,
                    hasCameraAccess : false
                } } );
            }

        } else if(curId==null && this.state.validCameraIds.length>0) {

            // ok - we didn't specifically know which one we were using
            // and on desktop if it was an overconstrained error - happy to retry
            this.switchToNextCamera();

        } else {

            // error state
            console.log('else error');

            this.setState( (state) => { return {
                hasCameraAccess : false
            } } );

        }

    }

    // ----------------------------------------------------------------------

    updateStatus(status, statusData) {

        this.setState((state) => { return { status: status, statusData: statusData } });        

    }

    // ----------------------------------------------------------------------

    addWinesToPastResults(wines) {

        // build new list
        let newScannedWineList = [];
        let winesAdded = [];

        // build list of unique wines

        wines.forEach(element => {
            let sku = element.productId;
            if(!winesAdded.includes(sku)) {
                newScannedWineList.push(element);
                winesAdded.push(sku);
            }
        });
        
        this.state.pastResults.forEach(element => {
            let sku = element.productId;
            if(!winesAdded.includes(sku)) {
                newScannedWineList.push(element);
                winesAdded.push(sku);
            }
        });
        
        // Truncate
        if(newScannedWineList.length>maxPastResultLength) newScannedWineList.length = maxPastResultLength;

        // Remember
        localStorage['scannedWines'] = JSON.stringify(newScannedWineList);
        
        this.setState( (state) => { return {
            pastResults : newScannedWineList
        } });

    }

    // ----------------------------------------------------------------------

    foundWines(wines) {
        // Fire event to GA
        event('Bottle Scanner', 'Status', 'Successful Scan');

        this.setState( (state) => {
            let delta = { wines : wines };
            if(wines.length==1) {
                delta.selectedWine = wines[0];
                this.addWinesToPastResults(wines);
            }
            return delta;
        });

        if(this.state.useCameraId!=null) {
            localStorage['lastGoodCameraId'] = this.state.useCameraId;
        }

    }

    // ----------------------------------------------------------------------

    onSelectWine(wine) {

        this.setState( (state) => { return { selectedWine: wine} } );
        
        /* code left in for the moment */
        this.addWinesToPastResults([wine]);

    }

    // ----------------------------------------------------------------------

    onNotThisWine() { this.setState( (state) => { return { selectedWine: null } }); }

    // ----------------------------------------------------------------------

    onTryAgain() { this.setState( (state) => { return { wines: [], selectedWine: null, timeLastStarted : (new Date()).getTime(), status :'scanning' } }); }

    // ----------------------------------------------------------------------

    onClickSearch() {

        try {
            document.getElementById('search').click(); // open the search panel
            // Fire event to GA
            event('Bottle Scanner', 'Click', 'Wine Search');

            /*
                // for reference only - how we might resize it
                let panel = document.querySelector('.desktop-search-panel'); // find it
                let box = document.getElementById('bsWhiteBox'); // find it
                
                panel.style.width = box.getBoundingClientRect().width + 'px';
            */

        } catch {
            console.log('Failed to open search');
        }
        
    }

    // ----------------------------------------------------------------------

    render() {
        
        // this code got messier than anticipated... tidy it up later

        let showCameraOptions = this.state.validCameraIds.length>1;

        let haveSelectedAWine = this.state.selectedWine!=null;
        let haveFoundWines = this.state.wines.length>0;
        let haveFoundMultipleWines = this.state.wines.length>1;
        let scanning = this.state.scanning;
        let useOverlay = haveSelectedAWine || haveFoundWines || scanning;

        let requestedCameraAccessResponded = this.state.requestedCameraAccessResponded;
        let canAccessCamera = this.state.hasCameraAccess;

        

        let status = this.state.status;
        let statusData = this.state.statusData;
        let showSearchButton = this.state.scanningTime > revealSearchButtonAfter;
        if(showSearchButton && status=='scanning') { status = 'still scanning'; }
        let noInternet = status == 'no internet';

        let viewName = 'scanner';
        if(haveSelectedAWine) viewName = 'singleWine';
        else if(haveFoundWines) viewName = 'wineList';
        else if(scanning && requestedCameraAccessResponded==false) viewName = 'requestAccess';
        else if(scanning && !canAccessCamera) viewName = 'cameraAccessError';

        return (

            useOverlay ?

                <div className={styles.greyOuterBox}>

                    <div id="bsWhiteBox" className={styles.whiteInnerBox}>

                        {viewName=='scanner' ?
                            <WineScanner
                                mappingDataURL = { this.props.mappingDataURL }
                                APIURLprefix = { this.props.APIURLprefix }
                                baseURL = { this.props.baseURL }
                                internetFlag = { this.state.internetFlag }
                                onStop={ () => this.stopScanning() }
                                onWinesFound= { (wines) => this.foundWines(wines) }
                                onStatusUpdate={ (status, statusData) => this.updateStatus(status, statusData) }
                                onError={ (err) => this.onScannerError(err) }
                                useCameraId={ this.state.useCameraId }
                                />
                            : null }

                        {(() => {
                            switch (viewName) {
                                
                                // --------------------------------------------------------
                                
                                case 'requestAccess': {

                                    return <RequestAccessView
                                        onStopScanning={ () => { this.stopScanning(); } }
                                        />

                                }

                                // --------------------------------------------------------

                                case 'singleWine': {

                                    return <SingleResult
                                        wine={ this.state.selectedWine }
                                        baseURL={ this.props.baseURL }
                                        productURL={ this.props.productURL }
                                        tastingNotesURL={ this.props.tastingNotesURL }
                                        onNotThisWine={ haveFoundMultipleWines ? () => { this.onNotThisWine(); } : null }
                                        onTryAgain={ () => { this.onTryAgain(); } }
                                        />;
                                }
                                
                                // --------------------------------------------------------

                                case 'wineList': {

                                    return <MultipleResults
                                        wines={this.state.wines}
                                        onSelectWine={ (wine) => { this.onSelectWine(wine); } }
                                        onTryAgain={ () => { this.onTryAgain(); } }
                                        />;                                
                                }

                                // --------------------------------------------------------

                                case 'cameraAccessError': {
                                    return <CameraAccessError />;                                    
                                }

                                // --------------------------------------------------------

                                case 'scanner':
                                default: {
                                    return  <div className={styles.bsOverlayPosition}>
                                                <div className={styles.bsScannerPage}>

                                                    <Status status={status} statusData={statusData} />
                                                    
                                                    <div className={styles.bsCenter}>

                                                        <div className={styles.bsViewFinder}>
                                                            <div className={styles.bsTopLeft}>&nbsp;</div>
                                                            <div className={styles.bsTopRight}>&nbsp;</div>
                                                            <div className={styles.bsBottomLeft}>&nbsp;</div>
                                                            <div className={styles.bsBottomRight}>&nbsp;</div>
                                                        </div>

                                                    </div>
                                                    { noInternet ?
                                                        <div className={ styles.bsFooterTwoButton }>
                                                             <button style={{gridArea:'wrong'}} className={styles.bsScannerOverlayButton} onClick={ (e) => { this.retryInternet(); } } >{lookup('buttonRetryInternet')}</button>
                                                            <button style={{gridArea:'exit'}} className={styles.bsScannerOverlayButton} onClick={ (e) => { this.stopScanning(); } } >{lookup('buttonExitBottleScanner')}</button>
                                                        </div>
                                                    :
                                                        <div className={ showCameraOptions ? styles.bsFooterTwoButton : styles.bsFooter}>
                                                            { showSearchButton ? <button style={{gridArea:'search'}} className={styles.bsScannerOverlayButtonHighlight} onClick ={ () => { 
                                                                this.onClickSearch(); } }>{lookup('buttonSearch')}</button> : null }
                                                            { showCameraOptions ? <button style={{gridArea:'wrong'}} className={styles.bsScannerOverlayButton} onClick={ (e) => {  this.switchToNextCamera(); return false; } } >{lookup('buttonChangeLens')}</button> : null }
                                                            <button style={{gridArea:'exit'}} className={styles.bsScannerOverlayButton} onClick={ (e) => { this.stopScanning(); } } >{lookup('buttonExitBottleScanner')}</button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                }                                                
                            }
                        })()}
                        
                        <a className={styles.bsClose} onClick={ (e) => { this.stopScanning(); return false; } } >&nbsp;</a>

                    </div>
                </div>
            :
                <div>
                    <button className="btn btn-primary" onClick={ (e) => { 
                        // Fire event to GA
                        event('Bottle Scanner', 'Click', 'Start Scanning');
                        return this.startScanning(); 
                    } } 
                    >{lookup('buttonStartScanning')}</button>
                    
                    { /*<PastResults results={this.state.pastResults} />*/}
                </div>
        )
    }

}

// --------------------------------------------------------------------------
export default WineEventsScanner;
// --------------------------------------------------------------------------
